module.exports = __webpack_public_path__ + "img/login-bg.7fc6ebee.jpg";